import api from "@/utils/api";

// Sends a file in chunks to /lms/admin/video-uploads/{id}/chunk, resuming on offset mismatch.
export async function uploadChunks(uploadId, file, chunkSize, onProgress) {
  let offset = 0;
  let retries = 0;
  while (offset < file.size) {
    const blob = file.slice(offset, offset + chunkSize);
    try {
      const { data } = await api.put(`/lms/admin/video-uploads/${uploadId}/chunk?offset=${offset}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
      offset = data.received; retries = 0;
    } catch (err) {
      const received = err.response?.data?.detail?.received;
      if (err.response?.status === 409 && typeof received === "number") { offset = received; continue; }
      if ((!err.response || err.response.status >= 500) && retries < 3) { retries += 1; await new Promise((r) => setTimeout(r, 1500 * retries)); continue; }
      throw err;
    }
    onProgress(Math.round((offset / file.size) * 100));
  }
}

export const fileSize = (n) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round((n || 0) / 1024))} KB`);
